var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBankTransferLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_62",
    "data-name": "Group 62",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.74,
    height: 74.156,
    viewBox: "0 0 74.74 74.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 2.965,
    cy: 2.965,
    r: 2.965,
    transform: "translate(34.362 13.02)",
    fill: "#63bff6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M71.821,470H2.92a2.92,2.92,0,0,0,0,5.839h68.9a2.92,2.92,0,0,0,0-5.839Z",
    transform: "translate(0 -401.683)",
    fill: "#63bff6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M74.74,20.246a2.92,2.92,0,0,0-1.735-2.668L38.482,2.25a2.919,2.919,0,0,0-2.374,0L1.731,17.58A2.92,2.92,0,0,0,0,20.246v7.737c0,.025,0,.048,0,.073s0,.048,0,.073a2.919,2.919,0,0,0,2.92,2.92c1.714,0,2.482,1.466,2.482,2.92V61.2c0,.061.006.121.009.181s-.009.12-.009.181a2.919,2.919,0,0,0,2.92,2.92H66.712a2.92,2.92,0,0,0,0-5.839H57.953V33.968a2.92,2.92,0,1,1,5.839,0V46.89a2.92,2.92,0,0,0,5.839,0V33.968c0-.685.158-2.92,2.19-2.92a2.919,2.919,0,0,0,2.92-2.92c0-.025,0-.048,0-.073s0-.048,0-.073ZM17.079,58.638H11.24V33.968a2.92,2.92,0,0,1,5.839,0Zm11.678,0H22.918V33.968a2.92,2.92,0,0,1,5.839,0Zm11.678,0H34.6V33.968a2.92,2.92,0,0,1,5.839,0Zm11.678,0H46.275V33.968a2.92,2.92,0,0,1,5.839,0ZM68.9,25.064H5.839V22.141L37.3,8.114l31.6,14.03Z",
    transform: "translate(0 -1.999)",
    fill: "#63bff6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransferLogo);
export default __webpack_public_path__ + "static/media/bankTransferLogo.0187cdc30d82a2e08227611e3c97596a.svg";
export { ForwardRef as ReactComponent };